(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["skullette-note-from-julie"] && !Shopify.designMode) return;
  try {
    // Signature wipe reveal - observe the parent wrapper, not the clipped node.
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    for (const wrap of document.querySelectorAll('.sk-note')) {
      const sig = wrap.querySelector('.sk-note__sig');
      if (!sig) continue;
      sig.classList.add('sk-note__sig--armed');
      new IntersectionObserver((entries, io) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            sig.classList.add('sk-note__sig--in');
            io.disconnect();
          }
        }
      }, { threshold: 0.35 }).observe(wrap);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
